import React, { Component } from 'react'
import './dropdown.scss'

class Dropdown extends Component {
	constructor(props) {
		super(props)
		this.state = {
			label: props.label ? props.label : '',
			options: props.options ? props.options : [],
			value: props.value ? props.value : '',
			state: props.state ? props.state : '',
			valueName: '',
			isOpen: false,
			showIcon: props.icon ? 'show-icon' : '',
			disableClickClose: this.props.disableClickClose
		}
		if (props.value) {
			let selected = this.state.options.filter(function (optionitem) {
				return optionitem.value === props.value
			})
			this.state.value = selected[0].value
			this.state.valueName = selected[0].text
		}
	}

	componentDidMount() {
		document.addEventListener('mousedown', this.handleClickOutside)
	}

	componentWillUnmount() {
		document.removeEventListener('mousedown', this.handleClickOutside)
	}

	setWrapperRef = (node) => {
		this.wrapperRef = node
	}

	// close dropdown if clicked outside of component
	handleClickOutside = (event) => {
		if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
			if (this.state.isOpen && !this.state.disableClickClose) this.setState({ isOpen: false })
		}
	}

	toggle = () => {
		this.setState({ isOpen: !this.state.isOpen })
	}

	selectOption = (option) => {
		this.props.onChange && this.props.onChange(option.currentTarget.dataset.value)
		this.setState({ value: option.currentTarget.dataset.value })
		this.props.onChange && this.props.onChange(option.currentTarget.dataset.value)
		let selected = this.state.options.filter(function (optionitem) {
			return optionitem.value === option.currentTarget.dataset.value
		})
		if (selected.length > 0) {
			this.setState({ valueName: selected[0].text })
			return this.props.randomFunc
		}
		// this.setState({valueName: selected[0].text})
	}

	render() {
		let show = this.state.isOpen ? 'show' : ''
		let icon = this.state.isOpen ? 'icon-up' : 'icon-down'
		let active = this.state.value ? 'active' : ''

		const classes = [
			'vbui--dropdown',
			this.props.classes,
			this.props.icon ? 'show-icon' : null,
			this.props.label ? null : 'no-label'
		].join(' ')

		const itemClasses = ['dropdown-items', show].join(' ')
		const buttonClasses = ['button-dropdown', this.props.buttonClasses, active, this.props.state, show].join(' ')
		let itemsClick = this.props.disableClickClose ? function () { } : this.toggle

		return (
			<div className={classes} ref={this.setWrapperRef}>
				{this.props.showIcon && this.props.icon && <span className={this.props.icon} />}
				{this.props.showIcon && <span className={icon}></span>}
				<input
					onClick={this.toggle}
					className={buttonClasses}
					name={this.props.name}
					placeholder={this.state.placeholder}
					type={this.props.type}
					value={this.state.valueName}
					//				onChange={this.state.valueName.length > 0 ? console.log('hay'):console.log('no hay') }
					required={this.props.required}
					readOnly
				/>
				<div className={itemClasses} onClick={itemsClick}>
					<ul className="list">
						{this.state.options.map(function (option, i) {
							if (option.value === this.state.value) {
								return (
									<li
										key={option.value + i + '_select'}
										className="active"
										data-value={option.value}
										onClick={this.selectOption}
									>
										{option.radio === true && <span className="radio" />}
										{option.icon && <i className={option.icon} />}
										<span>{option.text}</span>
									</li>
								)
							} else {
								return (
									<li key={option.value + i + '_select'} data-value={option.value} onClick={this.selectOption}>
										{option.radio === true && <span className="radio" />}
										{option.icon && <i className={option.icon} />}
										<span>{option.text}</span>
									</li>
								)
							}
						}, this)}
					</ul>
				</div>
				{this.props.label && <label>{this.props.label}</label>}
			</div>
		)
	}
}

export default Dropdown
